import { Autocomplete, Chip, TextField } from "@mui/material";
import React from "react";

function InputValue({ name, value }) {
  if (name == null) {
    return null;
  }

  return value.map((v) => (
    <input key={v} type="hidden" name={name + "[]"} value={v} />
  ));
}

/**
 * @param {string} [name]
 * @param {string[]} [defaultValue]
 * @param {string} [label]
 * @param {string} [disableRemove]
 */
export default function TagsInput(props) {
  const { name, defaultValue, label, disableRemove } = props;
  const [internalValue, setInternalValue] = React.useState(defaultValue ?? []);
  const value = internalValue;
  const disabledOptions = new Set(disableRemove ? (defaultValue ?? []) : []);

  return (
    <>
      <InputValue name={name} value={value} />
      <Autocomplete
        multiple
        disableCloseOnSelect
        sx={{ minWidth: "400px" }}
        value={value}
        renderInput={(params) => <TextField label={label} {...params} />}
        options={[]}
        freeSolo
        disableClearable
        onChange={(_, value) => {
          setInternalValue([
            ...disabledOptions,
            ...value.filter((option) => !disabledOptions.has(option)),
          ]);
        }}
        renderValue={(value, getItemProps) =>
          value.map((option, index) => {
            const { key, ...itemProps } = getItemProps({ index });

            return (
              <Chip
                key={key}
                label={option}
                size="small"
                {...itemProps}
                disabled={disabledOptions.has(option)}
              />
            );
          })
        }
      />
    </>
  );
}
